import { FC } from 'react';
import { PartnerPaymentStatus } from '@/models/payments';
import { useTranslation } from 'react-i18next';
import { cx } from '@emotion/css';

const config = {
  [PartnerPaymentStatus.COMPLETED]: {
    label: 'taxi_partner.payments.status.completed',
    color: 'text-green-700',
    bg: 'bg-green-100',
  },
  [PartnerPaymentStatus.DECLINED]: {
    label: 'taxi_partner.payments.status.declined',
    color: 'text-red-950',
    bg: 'bg-red-200',
  },
  [PartnerPaymentStatus.FAILED]: {
    label: 'taxi_partner.payments.status.failed',
    color: 'text-red-700',
    bg: 'bg-red-100',
  },
  [PartnerPaymentStatus.PENDING]: {
    label: 'taxi_partner.payments.status.pending',
    color: 'text-orange-700',
    bg: 'bg-orange-100',
  },
  [PartnerPaymentStatus.DELAYED]: {
    label: 'taxi_partner.payments.status.delayed',
    color: 'text-sky-700',
    bg: 'bg-sky-100',
  },
  [PartnerPaymentStatus.WAITING_FOR_INVOICE]: {
    label: 'taxi_partner.payments.status.waiting_invoice',
    color: 'text-green-700',
    bg: 'bg-green-100',
  },
  [PartnerPaymentStatus.NO_EARNINGS]: {
    label: 'taxi_partner.payments.status.no_earnings',
    color: 'text-gray-950',
    bg: 'bg-gray-100',
  },
  [PartnerPaymentStatus.PROCESSING_PAYMENT]: {
    label: 'taxi_partner.payments.status.processing_payment',
    color: 'text-white',
    bg: 'bg-orange-300',
  },
  [PartnerPaymentStatus.IN_REVIEW]: {
    label: 'taxi_partner.payments.status.in_review',
    color: 'text-white',
    bg: 'bg-blue-400',
  },
};

const defaultConfig = {
  label: 'taxi_partner.payments.status.unknown',
  color: 'text-gray-700',
  bg: 'bg-gray-200',
};

type Props = {
  status: PartnerPaymentStatus;
};

export const PaymentStatusChip: FC<Props> = ({ status }) => {
  const { bg, color, label } = config[status] || defaultConfig;
  const { t } = useTranslation();

  return (
    <div
      className={cx(
        'flex items-center justify-center bg-linear-to-r text-center py-1 px-4 rounded-2xl text-xs md:text-sm lg:text-base',
        bg,
        color
      )}
    >
      <span>{t(label)}</span>
    </div>
  );
};
